export default {
  manual: 'Manuel',
  filters: {
    status: 'Status',
    event_type: 'Hændelsestype',
  },
  columns: {
    event: 'Hændelse',
    status: 'Status',
    attempts: 'Forsøg',
    last_http_status: 'Seneste HTTP-status',
    created_at: 'Oprettet',
  },
  statuses: {
    pending: 'Afventer',
    delivered: 'Leveret',
    failed: 'Mislykket',
  },
  buttons: {
    details: 'Detaljer',
    resend: 'Send igen',
  },
  detail: {
    title: 'Leveringsdetaljer',
    event: 'Hændelse',
    attempts: 'Forsøg',
    no_attempts: 'Ingen forsøg endnu.',
    no_response: 'intet svar',
    payload: 'Payload',
  },
  toasts: {
    load_error: 'Leveringerne kunne ikke indlæses.',
    resend_error: 'Leveringen kunne ikke sendes igen.',
    resent: 'Levering sat i kø til gensendelse.',
  },
};
